import { Component } from '@angular/core';
import { CommonService } from '../services/common.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})

export class FooterComponent {

  isHttpActive: boolean;
  currentYear: any;

  constructor(private comm: CommonService) {

    this.currentYear = new Date().getFullYear();
    comm.OnInterception().subscribe(
      r => {
        this.isHttpActive = r;
      }
    );

  }

}
